// Every interface language ships its own manual (public/docs-<locale>.adoc).
// Listed explicitly because the dev server answers unknown paths with the SPA
// index instead of a 404, so a missing file would render as garbage.
export const MANUAL_LANGUAGES = ["da", "de", "en", "es", "fr", "hr", "hu", "it", "nl", "no", "pl", "pt", "ro", "sl"];

/**
 * Localized Asciidoctor attributes per manual language: the TOC title and the
 * admonition captions. Specially important for screen readers, as the
 * Asciidoctor defaults are in English.
 */
export const LOCALIZED_ATTRIBUTES: Record<string, Record<string, string>> = {
    en: {
        "warning-caption": "Attention",
    },
    da: {
        "toc-title": "Indholdsfortegnelse",
        "tip-caption": "Tip",
        "note-caption": "Bemærk",
        "warning-caption": "Advarsel",
        "caution-caption": "Forsigtig",
        "important-caption": "Vigtigt",
    },
    de: {
        "toc-title": "Inhaltsverzeichnis",
        "tip-caption": "Tipp",
        "note-caption": "Hinweis",
        "warning-caption": "Achtung",
        "caution-caption": "Vorsicht",
        "important-caption": "Wichtig",
    },
    es: {
        "toc-title": "Índice",
        "tip-caption": "Consejo",
        "note-caption": "Nota",
        "warning-caption": "Atención",
        "caution-caption": "Precaución",
        "important-caption": "Importante",
    },
    fr: {
        "toc-title": "Table des matières",
        "tip-caption": "Astuce",
        "note-caption": "Remarque",
        "warning-caption": "Attention",
        "caution-caption": "Prudence",
        "important-caption": "Important",
    },
    hr: {
        "toc-title": "Sadržaj",
        "tip-caption": "Savjet",
        "note-caption": "Napomena",
        "warning-caption": "Pažnja",
        "caution-caption": "Oprez",
        "important-caption": "Važno",
    },
    hu: {
        "toc-title": "Tartalomjegyzék",
        "tip-caption": "Tipp",
        "note-caption": "Megjegyzés",
        "warning-caption": "Figyelem",
        "caution-caption": "Vigyázat",
        "important-caption": "Fontos",
    },
    it: {
        "toc-title": "Indice",
        "tip-caption": "Suggerimento",
        "note-caption": "Nota",
        "warning-caption": "Attenzione",
        "caution-caption": "Cautela",
        "important-caption": "Importante",
    },
    nl: {
        "toc-title": "Inhoudsopgave",
        "tip-caption": "Tip",
        "note-caption": "Opmerking",
        "warning-caption": "Let op",
        "caution-caption": "Voorzichtig",
        "important-caption": "Belangrijk",
    },
    no: {
        "toc-title": "Innholdsfortegnelse",
        "tip-caption": "Tips",
        "note-caption": "Merk",
        "warning-caption": "Obs",
        "caution-caption": "Forsiktig",
        "important-caption": "Viktig",
    },
    pl: {
        "toc-title": "Spis treści",
        "tip-caption": "Wskazówka",
        "note-caption": "Informacja",
        "warning-caption": "Uwaga",
        "caution-caption": "Ostrożnie",
        "important-caption": "Ważne",
    },
    pt: {
        "toc-title": "Sumário",
        "tip-caption": "Dica",
        "note-caption": "Observação",
        "warning-caption": "Atenção",
        "caution-caption": "Cuidado",
        "important-caption": "Importante",
    },
    ro: {
        "toc-title": "Cuprins",
        "tip-caption": "Sfat",
        "note-caption": "Notă",
        "warning-caption": "Atenție",
        "caution-caption": "Precauție",
        "important-caption": "Important",
    },
    sl: {
        "toc-title": "Kazalo",
        "tip-caption": "Nasvet",
        "note-caption": "Opomba",
        "warning-caption": "Pozor",
        "caution-caption": "Previdno",
        "important-caption": "Pomembno",
    },
};

export function manualLanguage(locale: string): string {
    return MANUAL_LANGUAGES.includes(locale) ? locale : "en";
}
